import { useNavigation } from 'react-router-dom';
import { ButtonProps } from '../../../utils/helper-interfaces';
import classes from './blue-button.module.css';
import { FaSpinner } from 'react-icons/fa';


const BlueButton:React.FC<ButtonProps > = (props) => {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting";
  return (
    <button
      className={classes['button']}
      type={props.type??'button'} 
      onClick={props.onClick}
      disabled={props.isDisabled??false}
    >
      {isSubmitting ? (
        // Show loading spinner while submitting
        <FaSpinner className={`${classes.icon} ${classes.spinner}`} />
      ) : props.text}
    </button>
  )

}
export default BlueButton;